import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChildren,
} from '@angular/core';

import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbIconModule,
  NbSelectModule,
  NbInputModule,
  NbDatepickerModule,
} from '@nebular/theme';
import { SlicerComponent } from '../../../inventory/components/slicer/slicer.component';
import { SlicerComponentModule } from '../../../inventory/components/slicer/slicer.component.module';

export interface IEquipmentCountingFilter {
  label: string;
  field: string;
  selectedValues: string[];
  values?: any[];
  isLoading?: boolean;
}

export interface CustomDateRange {
  startDate: Date | null;
  endDate: Date | null;
}

@Component({
    selector: 'stack-mono-equipment-counting-slicers',
    templateUrl: './equipment-counting-slicers.component.html',
    styleUrls: ['./equipment-counting-slicers.component.scss'],
    imports: [
    FormsModule,
    NbButtonModule,
    NbIconModule,
    NbSelectModule,
    NbInputModule,
    NbDatepickerModule,
    SlicerComponentModule
]
})
export class EquipmentCountingSlicersComponent {
  @ViewChildren('slicer') slicers: SlicerComponent[];

  @Input() filters: IEquipmentCountingFilter[] = [];
  @Input() showClearFilter = false;
  @Input() resetFilters = false;
  @Input() dateRange = 'rolling_12';

  @Output() slicerChange = new EventEmitter<{
    filter: IEquipmentCountingFilter;
    selectedValues: any[];
  }>();
  @Output() slicerClose = new EventEmitter<boolean>();
  @Output() clearFiltersClick = new EventEmitter<void>();
  @Output() dateRangeChange = new EventEmitter<string>();
  @Output() customDateRangeChange = new EventEmitter<CustomDateRange>();

  customStartDate: Date | null = null;
  customEndDate: Date | null = null;

  onSlicerChange(
    filter: IEquipmentCountingFilter,
    selectedValues: any[],
  ): void {
    this.slicerChange.emit({ filter, selectedValues });
  }

  onSlicerClose(showLoading: boolean): void {
    this.slicerClose.emit(showLoading);
  }

  clearFilters(): void {
    this.clearFiltersClick.emit();
  }

  onDateRangeChange(value: string): void {
    this.dateRangeChange.emit(value);
    // Clear custom dates when switching away from custom range
    if (value !== 'custom_range') {
      this.customStartDate = null;
      this.customEndDate = null;
    }
  }

  onCustomDateChange(): void {
    if (this.customStartDate && this.customEndDate) {
      this.customDateRangeChange.emit({
        startDate: this.customStartDate,
        endDate: this.customEndDate,
      });
    }
  }
}
